/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AnalysisFilter } from './AnalysisFilter';
import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';

export type AnalysisRequest = {
    filter?: AnalysisFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: AnalysisRequest.exposeType;
}

export namespace AnalysisRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
